window.gift_wrap = {
  
  init: () => {
    window.gift_wrap.addListeners();
  },

  addListeners: () => {
    const buttons = document.querySelectorAll('.gift_wrap button:not(.event_is_set)');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const variant_id = button.getAttribute('data-variant-id');
        const button_name = button.getAttribute('name');
        if (button_name == 'add') {
          window.gift_wrap.addGiftWrap(variant_id);
        } else if (button_name == 'remove') {
          window.gift_wrap.removeGiftWrap(variant_id);
        }
        button.classList.add('loading');
      });

      button.classList.add('event_is_set');
    });
  },

  addGiftWrap: async (variant_id) => {
    const cart_page = document.querySelector('cart-page');
    const cart_drawer = document.querySelector('cart-drawer');

    if (cart_page) {
      cart_page.classList.add('adding_gift_wrap');
    } else if (cart_drawer) {
      cart_drawer.classList.add('adding_gift_wrap');
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variant_id,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error(`Error adding to cart: ${response.status}`);
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));

      if (cart_page) {
        window.gift_wrap.refreshCartPage();
        setTimeout(() => {
          cart_page.classList.remove('adding_gift_wrap');
        }, 500);
      } else if (cart_drawer) {
        window.gift_wrap.refreshCartDrawer();
        setTimeout(() => {
          cart_drawer.classList.remove('adding_gift_wrap');
        }, 500);
      }
    } catch (error) {
      console.error('Error:', error.message);

      if (cart_page) {
        window.gift_wrap.refreshCartPage();
        cart_page.classList.remove('removing_gift_wrap');
      } else if (cart_drawer) {
        window.gift_wrap.refreshCartDrawer();
        cart_drawer.classList.remove('removing_gift_wrap');
      }
    }
  },

  removeGiftWrap: async (variant_id) => {
    const cart_page = document.querySelector('cart-page');
    const cart_drawer = document.querySelector('cart-drawer');

    if (cart_page) {
      cart_page.classList.add('removing_gift_wrap');
    } else if (cart_drawer) {
      cart_drawer.classList.add('removing_gift_wrap');
    }

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variant_id,
          quantity: 0
        })
      });

      if (!response.ok) {
        throw new Error(`Error deleting product: ${response.status}`);
      }

      window.gift_wrap.refreshCartPage();

      if (cart_page) {
        window.gift_wrap.refreshCartPage();
        setTimeout(() => {
          cart_page.classList.remove('removing_gift_wrap');
        }, 500);
      } else if (cart_drawer) {
        window.gift_wrap.refreshCartDrawer();
        setTimeout(() => {
          cart_drawer.classList.remove('removing_gift_wrap');
        }, 500);
      }

    } catch (error) {
      console.error('Error:', error);

      if (cart_page) {
        window.gift_wrap.refreshCartPage();
        setTimeout(() => {
          cart_page.classList.remove('removing_gift_wrap');
        }, 500);
      } else if (cart_drawer) {
        window.gift_wrap.refreshCartDrawer();
        setTimeout(() => {
          cart_drawer.classList.remove('removing_gift_wrap');
        }, 500);
      }
    }
  },

  refreshCartPage: async () => {
    try {
      const res = await fetch(window.location.pathname, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newCart = doc.querySelector('cart-page');
      const currentCart = document.querySelector('cart-page');

      if (newCart) {
        newCart.querySelectorAll('.scroll-trigger').forEach(el => {
          el.classList.remove('scroll-trigger');
        });
      }

      if (newCart && currentCart) {
        currentCart.replaceWith(newCart);
        setTimeout(() => {
          window.gift_wrap.init();
        }, 50);
      }
    } catch (err) {
      console.error('Error refreshing cart page:', err);
    }
  },

  refreshCartDrawer: async () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.update === 'function') {
      cartDrawer.update();
    }
  }

};

window.gift_wrap.init();
